<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">

      <div class="row mb-4">
        <div class="col-12">
          <div class="title-wrapper">
            <div>
              <h1 class="title-default">Inventário de estoque</h1>
              <p class="welcome-message">
                <button mat-icon-button (click)="voltar()">
                  <mat-icon>arrow_back</mat-icon>
                </button>
                Selecione os filtros abaixo para gerar o relatório.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- ÁREA DE FILTROS -->
      <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="row search-area">

          <!-- Campos (limitados a 9/12 para criar a margem dinâmica à direita, igual ao search-area de outras listagens) -->
          <div class="col-12 col-md-9">
            <div class="row g-3 align-items-start">

              <!-- Linha 1: Busca | Situação -->
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Pesquisar</mat-label>
                  <input matInput formControlName="busca" placeholder="Pesquise por nome, código (SKU) ou GTIN/EAN" />
                  <button mat-icon-button matSuffix [matMenuTriggerFor]="refinarMenu" type="button">
                    <mat-icon>tune</mat-icon>
                  </button>
                  <mat-menu #refinarMenu="matMenu">
                    <button mat-menu-item type="button" (click)="refinarPor(0)">Não refinar</button>
                    <button mat-menu-item type="button" (click)="refinarPor(1)">Código (SKU)</button>
                    <button mat-menu-item type="button" (click)="refinarPor(2)">GTIN/EAN</button>
                    <button mat-menu-item type="button" (click)="refinarPor(3)">Descrição</button>
                  </mat-menu>
                  <button mat-icon-button matSuffix type="submit"><mat-icon>search</mat-icon></button>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Situação do produto</mat-label>
                  <mat-select formControlName="idSituacaoProduto">
                    <mat-option [value]="0">Todos</mat-option>
                    <mat-option [value]="1">Ativos</mat-option>
                    <mat-option [value]="2">Inativos</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Linha 2: Localização | Exibir | Fornecedor | Valor baseado em -->
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Localização</mat-label>
                  <mat-select formControlName="idLocalizacaoEstoque">
                    <mat-option [value]="null">Todas as localizações</mat-option>
                    @for (loc of listaLocalizacoes; track loc.id) {
                      <mat-option [value]="loc.id">{{ loc.descricao }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Exibir</mat-label>
                  <mat-select formControlName="idExibir">
                    <mat-option [value]="0">Todos os itens</mat-option>
                    <mat-option [value]="1">Apenas com estoque</mat-option>
                    <mat-option [value]="2">Apenas sem estoque</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Fornecedor</mat-label>
                  <mat-select formControlName="idFornecedor">
                    <mat-option [value]="null">Qualquer fornecedor</mat-option>
                    @for (forn of listaFornecedor; track forn.id) {
                      <mat-option [value]="forn.id">{{ forn.descricao }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Valor baseado em</mat-label>
                  <mat-select formControlName="idTipoValorBase">
                    <mat-option [value]="1">Preço da última compra</mat-option>
                    <mat-option [value]="2">Custo médio</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Linha 3: Categoria | Tags | Toggle -->
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Categoria</mat-label>
                  <mat-select formControlName="idCategoria">
                    <mat-option [value]="null">Todas</mat-option>
                    @for (cat of listaCategoria; track cat.id) {
                      <mat-option [value]="cat.id">{{ cat.descricao }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tags</mat-label>
                  <mat-select formControlName="listIdTag" multiple>
                    @for (tag of listaTag; track tag.idTag) {
                      <mat-option [value]="tag.idTag">{{ tag.nome }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 d-flex align-items-center toggle-field align-self-stretch">
                <mat-slide-toggle class="app-toggle-compact" formControlName="apenasComEstoque" color="primary">
                  Exibir estoque disponível
                </mat-slide-toggle>
              </div>

              <div class="col-12 filter-container">
                <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                  <mat-icon>cleaning_services</mat-icon>
                  Limpar Filtros
                </button>
                <button mat-flat-button class="btn-primary" type="submit" [disabled]="_isLoadingProdutos">
                  @if (_isLoadingProdutos) {
                    <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
                  } @else {
                    <mat-icon>filter_list</mat-icon>
                  }
                  Filtrar
                </button>
              </div>

            </div>
          </div>

        </div>
      </form>

    <!-- TABELA -->

      @if (_isLoadingProdutos && dataSource.length === 0) {
        <div class="loading-center">
          <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (!_isLoadingProdutos && dataSource.length === 0) {
        <app-empty-list [title]="'Nenhum produto encontrado'" [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
      } @else {
        <table mat-table class="desktop-view" [dataSource]="_flatDataSource" matSort>
          <ng-container matColumnDef="produto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Produto</th>
            <td mat-cell *matCellDef="let row">
              @if (row.isLocal) {
                <span class="local-indent" [class.local-indent--nivel3]="row.isVariacao">
                  <mat-icon class="local-link-icon">subdirectory_arrow_right</mat-icon>
                </span>
              } @else if (row.isVariacao) {
                <span class="variacao-indent">
                  <mat-icon class="variacao-icon">subdirectory_arrow_right</mat-icon>
                  {{ row.data.descricao }}
                </span>
              } @else {
                {{ row.data.descricao }}
                @if (row.data.variacoes.length) {
                  <span class="badge-variacoes">
                    {{ row.data.quantidadeVariacoes }} variações
                    <mat-icon class="icon-expand">{{ expandedElement === row.data ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </span>
                }
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="sku">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU</th>
            <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : (row.data.codigoSku || '—') }}</td>
          </ng-container>

          <ng-container matColumnDef="preco">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Custo médio</th>
            <td mat-cell *matCellDef="let row" class="text-end">
              {{ row.isLocal ? '' : (row.data.custoMedio | abnt:'preco') }}
            </td>
          </ng-container>

          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Unidade</th>
            <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : (row.data.unidade || '—') }}</td>
          </ng-container>

          <ng-container matColumnDef="localizacao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Local</th>
            <td mat-cell *matCellDef="let row">
              @if (row.isLocal) {
                <span class="local-name">{{ getLocalizacaoLabel(row) }}</span>
              } @else if (row.isVariacao) {
                @if (row.data.locais.length > 1) {
                  <span class="badge-locais">
                    {{ getLocalizacaoLabel(row) }}
                    <mat-icon class="icon-expand">{{ isVariacaoExpandida(row.data) ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </span>
                } @else {
                  {{ getLocalizacaoLabel(row) }}
                }
              } @else if (!row.data.variacoes.length && row.data.locais.length > 1) {
                <span class="badge-locais">
                  {{ getLocalizacaoLabel(row) }}
                  <mat-icon class="icon-expand">{{ expandedElement === row.data ? 'expand_less' : 'expand_more' }}</mat-icon>
                </span>
              } @else {
                {{ getLocalizacaoLabel(row) }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="saldo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Estoque atual</th>
            <td mat-cell *matCellDef="let row" class="text-end">
              <span [class.saldo-zerado]="getSaldo(row) === 0">
                {{ getSaldo(row) | abnt:'quantidade' }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [class.local-row]="row.isLocal"
            [class.variacao-row]="row.isVariacao && !row.isLocal"
            [class.parent-expanded-row]="!row.isLocal && !row.isVariacao && expandedElement === row.data"
            (click)="toggleRow(row)"
            [style.cursor]="isRowExpandivel(row) ? 'pointer' : 'default'"></tr>
        </table>

        <div class="mobile-view">
          @for (produto of dataSource; track produto.idProduto) {
            <div class="stock-card-mobile" [class.parent-expanded-row]="expandedElement === produto">
              <div class="stock-card-mobile__header">
                <div>
                  <strong>{{ produto.descricao }}</strong>
                  @if (produto.codigoSku) {
                    <small>SKU: {{ produto.codigoSku }}</small>
                  }
                </div>
              </div>

              <div class="stock-card-mobile__grid">
                <div>
                  <small>Custo médio</small>
                  <span>{{ produto.custoMedio | abnt:'preco' }}</span>
                </div>
                @if (formFiltro.get('apenasComEstoque')?.value) {
                  <div>
                    <small>Estoque atual</small>
                    <span [class.saldo-zerado]="produto.saldoTotal === 0">
                      {{ produto.saldoTotal | abnt:'quantidade' }}
                    </span>
                  </div>
                }
                <div>
                  <small>Local</small>
                  @if (produto.locais.length > 1) {
                    <span class="local-unico">{{ produto.locais.length }} locais</span>
                  } @else {
                    <span class="local-unico">{{ produto.localizacoes }}</span>
                  }
                </div>
              </div>

              @if (produto.variacoes.length) {
                <div class="stock-card-mobile__locais-toggle">
                  <button
                    mat-button
                    color="primary"
                    type="button"
                    class="w-100 text-start ps-0"
                    (click)="toggleMobileProduto(produto)">
                    <mat-icon>{{ expandedElement === produto ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ produto.quantidadeVariacoes }} Variações
                  </button>

                  @if (expandedElement === produto) {
                    <div class="stock-card-mobile__locais">
                      @for (variacao of produto.variacoes; track variacao.idProduto) {
                        <div class="variacao-item-mobile">
                          <div class="local-item">
                            <span class="local-name">
                              {{ variacao.descricao }}
                              @if (variacao.codigoSku) {
                                <small class="d-block text-muted">SKU: {{ variacao.codigoSku }}</small>
                              }
                            </span>
                            @if (formFiltro.get('apenasComEstoque')?.value) {
                              <span class="local-saldo">Estoque: {{ variacao.saldoTotal | abnt:'quantidade' }}</span>
                            }
                          </div>

                          @if (variacao.locais.length > 1) {
                            <button mat-button color="primary" type="button" class="w-100 text-start ps-3"
                                    (click)="toggleVariacaoLocais(variacao)">
                              <mat-icon>{{ isVariacaoExpandida(variacao) ? 'expand_less' : 'expand_more' }}</mat-icon>
                              {{ variacao.locais.length }} Locais
                            </button>

                            @if (isVariacaoExpandida(variacao)) {
                              <div class="stock-card-mobile__locais ps-3">
                                @for (local of variacao.locais; track local.idLocalizacaoEstoque) {
                                  <div class="local-item">
                                    <span class="local-name">{{ local.nomeLocalizacao }}</span>
                                    @if (formFiltro.get('apenasComEstoque')?.value) {
                                      <span class="local-saldo">Estoque: {{ local.saldoFisico | abnt:'quantidade' }}</span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else if (produto.locais.length > 1) {
                <div class="stock-card-mobile__locais-toggle">
                  <button
                    mat-button
                    color="primary"
                    type="button"
                    class="w-100 text-start ps-0"
                    (click)="toggleMobileProduto(produto)">
                    <mat-icon>{{ expandedElement === produto ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ produto.locais.length }} Locais
                  </button>

                  @if (expandedElement === produto) {
                    <div class="stock-card-mobile__locais">
                      @for (local of produto.locais; track local.idLocalizacaoEstoque) {
                        <div class="local-item">
                          <span class="local-name">{{ local.nomeLocalizacao }}</span>
                          @if (formFiltro.get('apenasComEstoque')?.value) {
                            <span class="local-saldo">Estoque: {{ local.saldoFisico | abnt:'quantidade' }}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

    <!-- Footer padrão -->
    <app-footer-action
      (salvar)="abrirEscolherFormato()"
      [isSalvarDisabled]="todosProdutos.length === 0"
      [hideCancelar]="true"
      salvarLabel="Escolher formato do inventário">
    </app-footer-action>

  </div>
</div>
